import { FC, useEffect, useRef } from "react";
import { TableLayout } from "./table-layout/TableLayout";
import { BookingTable, BookingProduct, LayoutLocation, DialogHandle } from "../types";
import { useApp } from "../context/useApp";
import { DEFAULT_DIALOG_HANDLE, metrics, SURCHARGE_NAME, UNASIGNED_ZONES, cache, rumba, DEFAULT_BOOKING_INSTRUCTIONS } from "../utils/symbols";
import { load, save } from "../utils/helpers";

export const TicketSelection: FC = () => {

    const {
        state: { booking, products, dialogHandles, priceRules, forcedRenders, tableMapHandle },
        actions: { genericError, updateProducts }
    } = useApp()

    const lastEventIdRequested = useRef(0)
    const dialogHandle:DialogHandle = dialogHandles.get('table-map-dialog') ?? DEFAULT_DIALOG_HANDLE
    const appDialog:DialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE

    const getProducts = async () => {
        
        if (booking.eventId === 0 || lastEventIdRequested.current === booking.eventId) return
        else lastEventIdRequested.current = booking.eventId
        
        const productsInCache = cache.get('products',booking.eventId)
        if (productsInCache) {
            updateProducts(productsInCache)
            return
        }

        // products are requested when a event is selected, so only request them 
        // if when loading the page, a event is already selected.
        const response = await rumba.getProducts(booking.date, booking.shiftId, booking.eventId)
        if (response.result !== 'ok') {
            genericError(() => getProducts())
            return
        }

        //map products with matching price rules discounts
        
        updateProducts(response.data)
        cache.add('products', booking.eventId, response.data)
    }

    const handleSeatClick = async (table: BookingTable, seatTicket: BookingProduct | undefined, layoutLocation: LayoutLocation) => {

        //display select shift first dialog if no event selected
        if (booking.eventId === 0) {
            dialogHandle.openDialog({
                dialog: 'select-shift-first',
                className: 'select-shift-first w-100 h-100 df aic jcc'
            }) 
            return
        }

        // change: show always
        // const { ticketsShown, ...rest } = load('localStorage', 'booking-instructions', DEFAULT_BOOKING_INSTRUCTIONS)
        // save('localStorage', 'booking-instructions', {...rest, ticketsShown: true})

        //if we are clicking the layout outside ticket selection step, go.
        //instead of set pointer events to none 
        if (booking.step === 'products' || booking.step === 'shift') booking.setBookingStep('tickets').render()

        //if the selected zones is an unasigned one, opens the dialog
        if (UNASIGNED_ZONES.includes(table.zone)) {
            appDialog.openDialog({
                dialog: 'unassigned-seats',
                zone: table.zone,
                category: seatTicket ? seatTicket.category : 'adult',
                className: 'unassigned-seats w-100 h-100 df aic jcc'
            })
            return
        }

        //if no surchage product is present, we can't continue the booking procces
        const surcharge = products.find(product => product.name === SURCHARGE_NAME)
        if (!surcharge) {
            genericError(() => handleSeatClick(table, seatTicket, layoutLocation))
            return
        }

        const action = seatTicket ? 'remove' : 'add'
        let ticket = null
        if (seatTicket) ticket = products.find(product => product.id === seatTicket.productId)
        else ticket = products.find(product => product.zone === table.zone && product.type === 'ticket' && product.category === 'adult')
        if (!ticket) return
        
        //surcharge will be calced on continue
        booking.removeSurcharge(surcharge)
        booking.handleTable(table)
        booking.unselectProducts()
        booking.handleProduct(action, ticket, layoutLocation).render()

        await metrics.ticketsSelectionEvent(booking.getBookingDataByReference())
    }

    useEffect(() => {
        getProducts()
    }, [forcedRenders])

    return (<TableLayout onSeatClick={handleSeatClick}/>)
}